import { useEffect, useState } from "react";
import { Loader2, Gift } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/apiClient";

export function BogoToggle() {
  const [enabled, setEnabled] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/promo/bogo").then((r) => setEnabled(!!r.data?.enabled)).catch(() => setEnabled(false));
  }, []);

  const toggle = async () => {
    if (saving || enabled === null) return;
    const next = !enabled;
    setSaving(true);
    try {
      const { data } = await api.post("/admin/promo/bogo", { enabled: next });
      setEnabled(!!data.enabled);
      toast.success(`Buy X Get X Free promotion ${data.enabled ? "enabled" : "disabled"}`);
    } catch {
      toast.error("Could not update the BOGO promotion.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="card-soft rounded-2xl p-6 mb-6" data-testid="bogo-toggle-card">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className="rounded-2xl p-3 bg-gradient-to-br from-[#f4e7c4] to-[#e6c665]/50 ring-1 ring-[#e6c665]/40">
            <Gift className="h-6 w-6 text-[#8a681c]" aria-hidden="true" />
          </div>
          <div>
            <h3 className="font-display font-bold text-lg">Buy X Get X Free Promotion</h3>
            <p className="text-sm text-muted-foreground mt-0.5 max-w-md">
              Every product &amp; dosage: buy N, get N free (max 10). 5% off the paid items on 2–9, 20% off on 10+. Site-wide — coupon codes don&rsquo;t stack while this is on.
            </p>
          </div>
        </div>
        <button
          onClick={toggle}
          disabled={saving || enabled === null}
          data-testid="bogo-toggle"
          aria-pressed={!!enabled}
          className={`relative inline-flex h-7 w-12 shrink-0 items-center rounded-full transition-colors ${enabled ? "bg-[#c59b27]" : "bg-[#d8cba6]"}`}
        >
          <span className={`inline-block h-6 w-6 transform rounded-full bg-white shadow transition-transform ${enabled ? "translate-x-5" : "translate-x-0.5"}`} />
        </button>
      </div>
      <p className="text-sm font-semibold mt-3" data-testid="bogo-toggle-status">
        {enabled === null ? <Loader2 className="w-4 h-4 animate-spin inline" aria-hidden="true" /> : enabled ? "Promotion is ON" : "Promotion is OFF"}
      </p>
    </div>
  );
}
